import script from "./SectionGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionGroup.vue?vue&type=script&setup=true&lang=js"

import "./SectionGroup.vue?vue&type=style&index=0&id=990d01fc&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-990d01fc"]])

export default __exports__